import React from 'react';
import Home from './pages/Home.js';
import Dashboard from './pages/Dashboard.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsOfUse from './pages/TermsOfUse.js';
import Accessibility from './pages/Accessibility.js';
import Login from './pages/Login.js';
import SignUp from './pages/SignUp.js';
import EventSetupWizard from './pages/EventSetupWizard.js';
import PublishedEventSummary from './pages/PublishedEventSummary.js';
import ViewMatch from './pages/ViewMatch.js';
import GiftPreferenceSurvey from './pages/GiftPreferenceSurvey.js';
import Unsubscribe from './pages/Unsubscribe.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import RedirectIfAuth from './components/RedirectIfAuth.js';
import Seo from './components/Seo.js';

// Token/session-scoped pages: every visitor sees different (or no)
// content behind the same URL, so they must never be indexed. noindex
// is rendered here (rather than inside each page) so it applies
// unconditionally, ahead of each page's own loading/error early-returns.
const NoIndex = ({ title, children }) => (
  <>
    <Seo noindex title={title} description={title} />
    {children}
  </>
);

// Shared route config, rendered both bare (default English) and nested
// under the `/:lang` prefix (see App.js). `path` is always the
// unprefixed, canonical app path.
export const routeConfig = [
  { path: '/', element: <RedirectIfAuth><Home /></RedirectIfAuth> },
  { path: '/dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
  { path: '/event-setup', element: <ProtectedRoute><EventSetupWizard /></ProtectedRoute> },
  { path: '/event/:eventId/edit', element: <ProtectedRoute><EventSetupWizard /></ProtectedRoute> },
  {
    path: '/event/:eventId/summary',
    element: <ProtectedRoute><NoIndex title="Event Summary | Kris Kindler"><PublishedEventSummary /></NoIndex></ProtectedRoute>,
  },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-of-use', element: <TermsOfUse /> },
  { path: '/accessibility', element: <Accessibility /> },
  { path: '/view-match', element: <NoIndex title="View Match | Kris Kindler"><ViewMatch /></NoIndex> },
  { path: '/gift-preferences', element: <NoIndex title="Gift Preferences | Kris Kindler"><GiftPreferenceSurvey /></NoIndex> },
  { path: '/unsubscribe', element: <NoIndex title="Unsubscribe | Kris Kindler"><Unsubscribe /></NoIndex> },
  { path: '/login', element: <RedirectIfAuth><Login /></RedirectIfAuth> },
  { path: '/signup', element: <RedirectIfAuth><SignUp /></RedirectIfAuth> },
];
